import React, { Component } from 'react';
import { closeOptionsMenu, desktop } from '../lib/functions';

class OptionsMenu extends Component {
    render() {
        return (
            <div id="options-menu-id" className="options-menu" hidden>
                <div className="menu-print-summary">
                    <div className="menu-button menu-desktop-button" onClick={desktop}>
                        <p>View on Desktop</p>
                        <p className="desktop-svg"><i className="fa fa-desktop"></i></p>
                    </div>
                    <div className="menu-button menu-summary-button" onClick={this.props.summaryPrint}>
                        <p>View Summary</p>
                        <p className="summary-svg"><i className="far fa-file-alt"></i></p>
                    </div>
                    <div className="menu-button menu-info-button" onClick={this.props.handleHelpMenu}>
                        <p>Help</p>
                        <p className="info-svg"><i className="fa fa-info"></i></p>
                    </div>
                </div>
                <div className="menu-button menu-cancel-button" onClick={closeOptionsMenu}>
                    <p className="menu-cancel">Cancel</p>
                </div>
            </div>
        );
    }
}

export default OptionsMenu;